<template>
  <el-table-column
    prop="target_storage_name"
    sortable="custom"
    label="Cél raktár"
    show-overflow-tooltip
    min-width="150"
  />
</template>

<script>
  export default {
    propName: 'target_storage_name',
  };
</script>
